export const UPLOADFILE = "upload_file";
export const UPLOADFILE_SUCCESSFULL = "upload_file_successfull";
export const DELETEFILE = "delete_file";
export const DELETEFILE_SUCCESSFULL = "delete_file_successfull";
export const UPLOADED_FILES_OF_INVOICE = "uploaded_files_of_invoice";
export const UPLOADED_FILES_OF_CHALLAN = "uploaded_files_of_challan";
export const UPLOADED_FILES_OF_SUPPDOCS = "uploaded_files_of_suppdocs";
export const UPLOADED_FILES_OF_INVOICE_SUCCESSFULL = "uploaded_files_of_invoice_successfull";
export const UPLOADED_FILES_OF_CHALLAN_SUCCESSFULL = "uploaded_files_of_challan_successfull";
export const UPLOADED_FILES_OF_SUPPDOCS_SUCCESSFULL = "uploaded_files_of_suppdocs_successfull";